import React from "react";
import { useSearchParams } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { exchangeCurrencyStore } from "@/shared/store/exchangeCurrencyStore";
import useGetOrderHistoryConfirmedList from "@/features/my-order/features/order-history/features/final-copy/hooks/query/useGetOrderHistoryConfirmedList";

/**
 * 확정본 금액의 통화.
 *
 * 확정가는 라인시트세트 통화 그대로 온다(원화 라인시트면 원화). 통화 스위치(₩)는 외화 라인시트에서만
 * 원화로 환산해 보여주고, 원화 라인시트는 바꿀 통화가 없어 스위치를 감추고 환산하지 않는다.
 */
export default function useFinalCopyCurrency() {
  const [searchParams] = useSearchParams();
  const orderSheetSetId = searchParams.get("order_sheet_set_id");
  const { confirmedData } = useGetOrderHistoryConfirmedList(
    orderSheetSetId ? +orderSheetSetId : 0
  );
  const exchangeCurrencyInfo = useRecoilValue(exchangeCurrencyStore);

  const baseCurrency =
    confirmedData.products.find((product) => product.confirmed_price?.currency)
      ?.confirmed_price?.currency ?? "EUR";
  const isBaseKrw = baseCurrency === "KRW";
  // 원화로 환산해 보여주는 중인지 — 원화 라인시트는 환산하지 않는다
  const isConverting = !isBaseKrw && searchParams.get("currency") === "KRW";
  const displayCurrency = isConverting ? "KRW" : baseCurrency;

  const exchangeCurrencyValue = React.useMemo(() => {
    if (!isConverting) {
      return 1;
    }
    // Fallback if not loaded
    return exchangeCurrencyInfo[baseCurrency]?.pathrade_send_rate || 1400;
  }, [isConverting, baseCurrency, exchangeCurrencyInfo]);

  return {
    baseCurrency,
    isBaseKrw,
    displayCurrency,
    // 표시 단가 반올림 규칙(원화는 정수)
    isDisplayKrw: displayCurrency === "KRW",
    exchangeCurrencyValue,
  };
}
